<template>
  <gj-modal
      size="700XAuto"
      :visible.sync="modalVisible"
      :loading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>店铺授权</template>
    <template #content>
      <storeAuthorization
          ref="storeAuthorization"
          :form="form"
          :marketItem="marketItem"
          :unionAccountOption="unionAccountOption"
          @passChange="storePassChange"
          :afresh="true"
      ></storeAuthorization>
      <!--&lt;!&ndash;      <p>{{market | json}}</p>&ndash;&gt;-->
      <!--      <gj-alert-->
      <!--          border-->
      <!--          show-icon>-->
      <!--        <div style="color: red;">为防止关联，请在亚马逊店铺常用电脑上添加授权。</div>-->
      <!--        <div>点击授权按钮后将跳转到亚马逊登录页面。</div>-->
      <!--      </gj-alert>-->
      <!--      <div style="margin: 20px 0;">-->
      <!--        <div style="margin-bottom: 4px;">-->
      <!--          <span class="gj-lable">区域：</span>-->
      <!--          <span class="gj-content">{{ market.region | optionText(MarketEnum.regionOption) }}</span>-->
      <!--        </div>-->
      <!--        <div style="margin-bottom: 4px;">-->
      <!--          <span class="gj-lable">店铺：</span>-->
      <!--          <span class="gj-content">{{ market.marketName }}</span>-->
      <!--        </div>-->
      <!--        <div>-->
      <!--          <span class="gj-lable">国家：</span>-->
      <!--          <span class="gj-content">{{ market.countryCode | optionText(countryOption) }}</span>-->
      <!--        </div>-->
      <!--      </div>-->
    </template>
    <template #footer>
      <gj-button class="handle-button" @click="$gjDestroy()" :loading="confirmLoading">取消</gj-button>
      <gj-button class="handle-button" type="primary" @click="confirm" :loading="confirmLoading">授权</gj-button>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn, responseMixin} from "../../../../../minxins";
import {getMarketAuthUrl, marketApiAuth} from "../../../../../api/system";
import {MarketEnum} from "../enum";
import {countryOption} from "../../../../../utils/options";

import storeAuthorization from "../components/store-authorization"
import {transformToMap} from "@/utils/common";

export default {
  name: "app-reauth-market-modal",
  mixins: [modalMixIn, responseMixin],
  components: {
    storeAuthorization
  },
  props: {
    market: {
      required: true
    },
    marketItem: null
  },
  data() {
    return {
      //店铺授权是否验证
      storePass: 'none',

      MarketEnum: MarketEnum,

      confirmLoading:false,

      // countryOption: countryOption,

      areaOption: MarketEnum.areaOption,
      countryOption: [],
      form: {
        marketName: null,
        areaId: 'na',
        countryCodes: [],
        unionAccount: true
      },
      unionAccountOption: [
        {id: true, text: '是'},
        {id: false, text: '否'},
      ],
    }
  },
  created() {
    this.form = {
      marketName: this.market.marketName,
      areaId: this.market.region,
      unionAccount: true,
      countryCodes:[this.market.countryCode]
    }




    // window.$marketAuthCallback = this.$marketAuthCallback;
  },
  // mounted() {
  //   this.$nextTick(()=>{
  //     console.log(this.$refs)
  //     this.$refs.storeAuthorization.disabled = true;
  //   })
  // },
  methods: {
    areaInput(areaId) {
      const map = transformToMap(this.areaOption);
      this.countryOption = map[areaId].countryOption;
      this.form.countryCodes = [];
      let areaList = ['IN', 'AE', 'SA', 'SG', 'AU', 'JP']
      areaList.includes(areaId) && (this.form.countryCodes = [areaId])
    },

    storePassChange(storePass) {
      this.storePass = storePass;
    },

    confirm() {
      if (this.storePass !== 'success') {
        this.$gjMessage.warning('验证成功后才可授权')
        return
      }
      this.confirmLoading = true;
      this.$refs.storeAuthorization.saveMarket(() => {
            this.confirmLoading = false;
            this.$emit('authed');
            this.$gjDestroy()
          },
          () => {
            this.confirmLoading = false;
          }
      )

      // getMarketAuthUrl({
      //   region: this.market.region,
      //   countryCodes: [this.market.countryCode]
      // })
      //     .then((authUrl) => {
      //       window.open(authUrl, "DisplayWindow", "toolbar=no,,menubar=no,location=no,scrollbars=no,height=610px,width=800px");
      //     })
      //     .complete(() => {
      //       this.confirmLoading = false;
      //     });
    },
    $marketAuthCallback(data) {
      this.confirmLoading = true;
      this.confirmText = '授权中';
      marketApiAuth(data)
          .then((res) => {
            this.$gjResponseHandle(res, () => {
              this.$gjMessage.success('授权成功');
              this.$emit('authed');
              this.$gjDestroy();
            });
          })
          .complete(() => {
            this.confirmLoading = false;
            this.confirmText = '授权';
          });
    }
  }
}
</script>

<style scoped>
.form {
  height: 170px;
}

.country-checkbox {
  margin: 10px 0 0;
}

.country-checkbox /deep/ .el-form-item__label,
.country-checkbox /deep/ .el-form-item__content {
  line-height: 20px;
}
</style>
